import axios from 'axios';
import type { DynamicField } from '@/models/dynamicField';

class DynamicFieldWebservice {
    public load() {
        return axios.get<DynamicField[]>('/dynamic_fields');
    }

    public getById(riskId: number) {
        return axios.get<DynamicField>('/dynamic_fields/getById', {
            params: {
                id: riskId,
            },
        });
    }

    public store(dynamicField: DynamicField) {
        return axios.post('/dynamic_fields/store', {
            title: dynamicField.title,
            description: dynamicField.description,
            order: dynamicField.order,
            color: dynamicField.color,
            value: dynamicField.value,
        });
    }

    public update(dynamicField: DynamicField) {
        return axios.post('/dynamic_fields/update', {
            id: dynamicField.id,
            title: dynamicField.title,
            description: dynamicField.description,
            order: dynamicField.order,
            color: dynamicField.color,
            value: dynamicField.value,
        });
    }

    public remove(dynamicField: DynamicField) {
        return axios.post('/dynamic_fields/remove', {
            id: dynamicField.id,
        });
    }
}

export const dynamicFieldWebservice = new DynamicFieldWebservice();
